import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenNl = () => {
    return <AddStartpageComToYourHomeScreen languageCode="nl" />
}

export default AddStartpageComToYourHomeScreenNl
